module.exports = __webpack_public_path__ + "img/i.7240bb90.png";